module.exports = __webpack_public_path__ + "media/images/footer/pan-764986e17866ec268120cfbc8ce80bb2.svg";